import React from 'react';
import MediaContext from "app/app/mediaSelector/contexts/MediaContext";


function MediaProvider(props) {
    const [media, setMedia] = React.useState(props.media || []);

    return (
        <MediaContext.Provider value={media}>
            {props.children}
        </MediaContext.Provider>
    );
}

export default MediaProvider;
